import React, { useMemo, useState } from "react";
import { CustomForm } from "shared/AllInputs";
import CustomOverlay from "shared/CustomOverlay";
import { useDispatch } from "react-redux";
import CustomViewTable from "views/Tables/CustomViewTable";
import { NumberEditor } from "views/Tables/TableInputs";
import CrossIcon from "assets/images/svg/cross-icon.svg";
import SaveIcon from "assets/images/svg/Save-icon.svg";
import SizeM2 from "assets/images/svg/SizeM2.svg";
import EuroIcon from "assets/images/svg/euroIcon.svg"
import { checkIsValueLower, showFormErrors } from "utils/commonFunctions";
import { deleteHeatingCostAction, getHeatingCostDetailsAction, updateHeatingCostAction } from "store/actions/rentsetupActions";
import CustomDeleteModal from "shared/Modals/CustomDeleteModal";
import { CustomAmountViewInput, CustomNumberViewInput } from "shared/AllViewInputs";
export default function ViewHeatingCostTable({
    id,
    title,
    allValues,
    setAllValues,
    header
}) {
    const dispatch = useDispatch();
    const [editingRows, setEditingRows] = useState({});
    const [deleteModal, setDeleteModal] = useState(false);
    const [loading, setLoading] = useState(false);
    const [idToDelete, setIdToDelete] = useState({ id: "", index: "" });

    const columns = useMemo(
        () => [
            {
                name: "Size From",
                accessor: "size_from",
                value: true,
                editor: (options) => NumberEditor({ name: "size_from", options: options, inputIcon: SizeM2, allValues: allValues, setAllValues: setAllValues }),
                body: (options) => <CustomNumberViewInput value={options.size_from} spanIcon={SizeM2} />
            },
            {
                name: "Size To",
                accessor: "size_to",
                value: true,
                editor: (options) => NumberEditor({ name: "size_to", options: options, inputIcon: SizeM2, allValues: allValues, thanField: "size_from", minSize: options?.rowData?.size_from }),
                body: (options) => <CustomNumberViewInput value={options.size_to} spanIcon={SizeM2} />
            },
            {
                name: "Cost by sqm(Oil)",
                accessor: "cost_oil",
                value: true,
                editor: (options) => NumberEditor({ name: "cost_oil", options: options, inputIcon: EuroIcon, allValues: allValues }),
                body: (options) => <CustomAmountViewInput value={options?.cost_oil} />
            },
            {
                name: "Cost by sqm(Gas)",
                accessor: "cost_gas",
                value: true,
                editor: (options) => NumberEditor({ name: "cost_gas", options: options, inputIcon: EuroIcon, allValues: allValues }),
                body: (options) => <CustomAmountViewInput value={options?.cost_gas} />
            },
            {
                name: "Cost by sqm(Electricity)",
                accessor: "cost_electricity",
                value: true,
                editor: (options) => NumberEditor({ name: "cost_electricity", options: options, inputIcon: EuroIcon, allValues: allValues }),
                body: (options) => <CustomAmountViewInput value={options?.cost_electricity} />
            },
        ],
        []
    );

    const handleEditRow = (rowData) => {
        const val = { ...{ [`${rowData?.id}`]: true } };
        setEditingRows(val);
    };

    const handleSave = async (rowData, options, e) => {
        options?.rowEditor?.onSaveClick(e);
        const val = { ...{ [`${rowData?.id}`]: true } };
        setEditingRows(val);
    };

    const onCancel = (id) => {
        dispatch(
            getHeatingCostDetailsAction(id, (res) => {
                let values = [...allValues];
                const indexToUpdate = values.findIndex((item) => item?.id === id)
                values[indexToUpdate] = res
                setAllValues(values)
            })
        );
    }

    const actions = (rowData, options) => {
        return (
            <>
                {options.rowEditor?.editing ? (
                    <>
                        <a
                            className="cursor-pointer"
                            onClick={(e) => handleSave(rowData, options, e)}
                        >
                            <img src={SaveIcon} />
                        </a>
                        <a
                            className="cursor-pointer"
                            onClick={(e) => {
                                options.rowEditor?.onCancelClick &&
                                    options.rowEditor?.onCancelClick(e)
                                onCancel(rowData?.id)
                            }}
                        >
                            {" "}
                            <img src={CrossIcon} />
                        </a>
                    </>
                ) : (
                    <>
                        <CustomOverlay>
                            <ul className="no-style p-0">
                                <li
                                    className="flex gap-2 text-xs font-medium mb-3 cursor-pointer"
                                    onClick={() => handleEditRow(rowData)}
                                >
                                    <i className="pi pi-file-edit text-dark"></i>
                                    Edit
                                </li>
                                <li
                                    className="flex gap-2 text-xs font-medium mb-3 cursor-pointer"
                                    onClick={() => {
                                        setIdToDelete({
                                            id: rowData?.id,
                                            index: options?.rowIndex,
                                        });
                                        setDeleteModal(true);
                                    }}
                                >
                                    <i className="pi pi-trash  text-dark"></i> Delete
                                </li>
                            </ul>
                        </CustomOverlay>
                    </>
                )}
            </>
        );
    };

    const onRowEditChange = (e) => {
        setEditingRows(e.data);
    };

    const rowEditValidator = async (rowData, options) => {
        const isValueLower = checkIsValueLower(rowData?.size_to, rowData?.size_from)
        if (showFormErrors(rowData) && !isValueLower) {
            dispatch(
                updateHeatingCostAction(rowData, dispatch, (res) => {
                    let values = [...allValues];
                    values[options.rowIndex] = rowData;
                    setAllValues(values);
                    setEditingRows({});
                    return true;
                })
            );
        } else {
            return false;
        }
    };

    const onDelete = () => {
        setLoading(true);
        dispatch(
            deleteHeatingCostAction(idToDelete?.id, setLoading, dispatch, (res) => {
                let values = [...allValues];
                let filtered = values.filter((item, itemIndex) => itemIndex !== idToDelete?.index)
                setAllValues(filtered)
                setIdToDelete({ id: "", index: "" });
                setDeleteModal(false);
            })
        );
    };

    return (
        <CustomForm title={title} header={header}>
            <CustomViewTable
                allValues={allValues}
                editingRows={editingRows}
                onRowEditChange={onRowEditChange}
                rowEditValidator={rowEditValidator}
                onRowEditSave={handleSave}
                columns={columns}
                actions={actions}
            />
            <CustomDeleteModal
                isOpen={deleteModal}
                setIsOpen={setDeleteModal}
                onSubmit={onDelete}
                loading={loading}
                item={"heating cost"}
            />
        </CustomForm>
    );
}
